<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc"><a href="#/preface">Preface</a></p>
<p class="toc"><a href="#/back">Background</a></p>
<p class="toc1"><a href="#/chapter01">Esther Headon: Disaffected</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">Benjamin White: Pacifist</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">Deborah Williams: Businesswoman</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">Richard Laird: Radical Revolutionary</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">Mary Taylor: Libertine</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">Sip: Black Loyalist</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">James Hulse: Reluctant Revolutionary</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">Sarah Chadwick: Child of a Revolutionary Leader</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">Thomas Okerson: Loyalist Officer</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">Jeremiah Chadwick: Revolutionary Officer</span></p>
<p class="toc1"><span href="#/post" title="Link target outside of Sample">Postscript</span></p>
<p class="toc"><span href="#/appendix" title="Link target outside of Sample">Appendix: Fact, Fiction and Conjecture in <i>The Razing of Tinton Falls</i></span></p>
<p class="toc"><span href="#/about" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?290fcaa5